<template>
    <v-select
        :class="{'error': error}"
        :modelValue="modelValue"
        :options="options"
        :placeholder="placeholder"
        @update:modelValue="emitValue"
        :label="labelKey"
        :reduce="reduce"
    >
        <!-- Scope all slots defined on input-select into v-select -->
        <template v-for="(slot, name) of $slots" v-slot:[name]="scope">
            <slot :name="name" v-bind="scope"></slot>
        </template>
    </v-select>
</template>
<script>
import vSelect from 'vue-select';
import InputError from '@/Components/Forms/Inputs/InputError.vue';

export default {
    components: {InputError, vSelect},
    props: {
        modelValue: [Object, String, Number],
        options: Array,
        placeholder: String,
        error: String,
        labelKey: String,
        reduce: Function
    },
    methods: {
        emitValue($event) {
            this.$emit("update:modelValue", $event);
        }
    },
};
</script>

<style lang="scss" scoped>
.v-select {
    @apply cursor-pointer;

    :deep {
        --vs-controls-color: theme('colors.dark');
        --vs-border-color: theme('colors.grey.200');
        --vs-border-width: 2px;
        --vs-border-style: solid;
        --vs-border-radius: theme('borderRadius.DEFAULT');
        --vs-search-input-color: theme('colors.dark');
        --vs-selected-bg: theme('colors.white');
        --vs-selected-color: theme('colors.dark');
        --vs-selected-border-color: theme('colors.grey.200');
        --vs-dropdown-option-color: theme('colors.dark');
        --vs-dropdown-option--active-bg: theme('colors.primary');
        --vs-dropdown-option--active-color: theme('colors.white');
        --vs-search-input-placeholder-color: #6e7583;

        .vs__dropdown-menu {
            max-height: 180px;
        }

        .vs__dropdown-toggle {
            @apply min-h-[52px] bg-white cursor-pointer;
        }

        .vs__selected-options {
            @apply items-center;
            width: 95%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .vs__search {
            @apply cursor-pointer;
        }
        .vs--multiple {
            height: auto !important;
        }
        .vs__selected {
            border-radius: 0 !important;
            padding: 0.5em 0.75em;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 90%;
        }
    }

    &.vs--open {
        :deep {
            --vs-border-color: theme('colors.grey.200');
        }
    }
}

.error {
    :deep {
        --vs-border-color: theme('colors.danger');
    }
}
</style>
